// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__10U1m","errorLogs":"styles_errorLogs__69Zr3"};